<template>
  <div class="bottom-scroll" v-scroll-to="to">
    <span>SCROLL</span>
  </div>
</template>

<script>
export default {
  name: "BottomScroll",
  props: {
    to: String
  }
};
</script>

<style lang="scss">
.bottom-scroll {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 120px;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  transition: opacity 3s;
  transition-delay: 1s;
  &:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -0.5px;
    width: 1px;
    height: 100%;
    background: rgba(255, 255, 255, 0.15);
    z-index: 0;
    transition: transform 1s;
    transform-origin: 0 100%;
    transition-delay: 1s;
    transform: scaleY(1);
  }
  span {
    color: $white;
    background-image: linear-gradient(currentColor, currentColor);
    background-position: 0% 100%;
    background-repeat: no-repeat;
    background-size: 0% 2px;
    transition: all 0.3s;
  }
  &:hover {
    span {
      color: $pink;
      background-size: 100% 2px;
    }
  }
}
@media (max-width: $mobile) {
  .bottom-scroll {
    font-size: 14px;
    height: 80px;
  }
}
</style>